import React from "react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { CalendarIcon } from "lucide-react";

function toIso(d) {
  return d ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` : "";
}

export function DatePicker({ value, onChange, placeholder = "Pick a date", testid, className = "" }) {
  const [open, setOpen] = React.useState(false);
  const date = value ? new Date(value + "T00:00:00") : undefined;
  const label = date ? date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : placeholder;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" data-testid={testid} className={`justify-start font-normal h-10 ${date ? "text-slate-800" : "text-slate-400"} ${className}`}>
          <CalendarIcon size={15} className="mr-2 text-slate-400" />{label}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={date} onSelect={(d) => { onChange(toIso(d)); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
